import useSWR from "swr";
import { getWatchListTypes } from "./watch-list-service";
import { UseWatchListTypeModel } from "./types";

const useWatchListType = (): UseWatchListTypeModel => {
  const { data, error, isLoading, mutate } = useSWR(`/watch-list/types`, () =>
    getWatchListTypes(),
  );

  return {
    data: data?.results,
    isLoading,
    error,
    mutate,
  };
};

export default useWatchListType;
